define("Ames.CustomMerchantZone.CustomMerchantZone", [
  "Ames.CustomMerchantZone.CustomMerchantZone.View",
  "CustomMerchantZone.MoreItems.View"
], function (CustomMerchantZoneView, CustomMerchantZoneMoreItemsView) {
  "use strict";

  return {
    mountToApp: function mountToApp(application) {
      CustomMerchantZoneView.prototype.application = application;
      application.getComponent("CMS").registerCustomContentType({
        id: "cct_custommerchantzone",
        view: CustomMerchantZoneView,
      });

      var pageTypeComponent = application.getComponent("PageType");
			var pageType = {
				name: 'custom_merchant_zone_more_items',
				view: CustomMerchantZoneMoreItemsView,
				routes: ['custom-merchant-zone-more-items', 'custom-merchant-zone-more-items?:commerceCategory'],
				options: {},
				defaultTemplate: {
					name: 'custommerchantzone_more_items.tpl',
					displayName: 'Merchant Zone More Items'
				}
			}

			pageTypeComponent.registerPageType(pageType);
    },
  };
});
